import React from 'react';
import { Logo } from 'Components/Logo';
import './Invoice.css';
import { CardInfo } from 'Components/CardInfo';
import PayPalInfo from 'Features/Payment/PayPalInfo';
import { ApplePayInfo } from 'Features/Payment/ApplePayInfo';

export const Invoice = ({
  invoice: {
    invoiceId,
    hasDiscounts,
    displayName,
    billDate,
    billingPeriod,
    totalTaxCharged,
    cardType,
    cardNumber,
    paymentType,
    paypalEmail,
    applePayID,
    totalCharged,
    retailPrice,
    chargedPrice,
    discountsDesc,
    discountsAmount,
  },
  user: { email },
}) => {
  const invoiceClassNames = discountsDesc ? 'invoice hasDiscount' : 'invoice';
  return (
    <div className="invoiceContainer">
      <div className="invoiceLogo">
        <Logo className="invoiceLogoImg" />
      </div>
      {
        <div className="customerInfo">
          <span className="customerInfoLabel">Customer</span>
          <span className="customerInfoItem" data-dd-privacy="mask" data-heap-redact-text>
            {email}
          </span>
        </div>
      }

      <div className="invoiceInfo">
        <span>Statement #</span>
        <span>{invoiceId}</span>
      </div>

      <div className={invoiceClassNames}>
        <dl className="invoiceEntry date">
          <dt className="listTerm">Date</dt>
          <dd className="listDescription">{billDate}</dd>
        </dl>
        <dl className="invoiceEntry desc">
          <dt className="listTerm">Description</dt>
          <dd className="listDescription">{displayName}</dd>
        </dl>
        <dl className="invoiceEntry period">
          <dt className="listTerm">Service period</dt>
          <dd className="listDescription">{billingPeriod}</dd>
        </dl>
        <dl className="invoiceEntry amount">
          <dt className="listTerm">Amount</dt>
          <dd className="listDescription">${retailPrice}</dd>
        </dl>
        {hasDiscounts && discountsDesc && discountsAmount > 0 && (
          <div className="discount desc">
            <span className="desc">{discountsDesc}</span>
            <span className="amount">{`-$${discountsAmount}`}</span>
          </div>
        )}
      </div>

      <div className="invoiceFooter">
        <dl className="invoiceFooterItem">
          <dt className="listTerm">
            <span className="invoiceFooterLabel">Subtotal</span>
          </dt>
          <dd className="listDescription">${chargedPrice}</dd>
        </dl>
        <dl className="invoiceFooterItem">
          <dt className="listTerm">
            <span className="invoiceFooterLabel">Tax</span>
          </dt>
          <dd className="listDescription">${totalTaxCharged}</dd>
        </dl>
        <dl className="invoiceFooterItem total">
          <dt className="listTerm">
            <span className="invoiceFooterLabel">Total Paid</span>
          </dt>
          <dd className="listDescription">{totalCharged}</dd>
        </dl>
      </div>
      {paymentType === 'Credit/Debit Card' && (
        <div className="invoicePayment">
          <div className="invoicePaymentLabel">Payment Method</div>
          <div className="sectionFlex flexGrowThree cardNumber" data-dd-privacy="mask" data-heap-redact-text>
            <CardInfo cardNumber={cardNumber} cardType={cardType} />
          </div>
        </div>
      )}
      {paymentType === 'PayPal Account' && (
        <div className="sectionFlex paymentDetailItem">
          <PayPalInfo email={paypalEmail} />
        </div>
      )}
      {paymentType === 'ApplePay' && (
        <div className="sectionFlex paymentDetailItem">
          <ApplePayInfo applePayID={applePayID} />
        </div>
      )}
    </div>
  );
};
